angular.module('impactx.catalog').controller('CatalogApprovalStopCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'themeFactory',
    CatalogApprovalStopCtrl]);

function CatalogApprovalStopCtrl($scope, dataGen, $mdDialog, themeFactory) {
    $scope.comment = "";
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {}, "/catalog/approvalstoptranslations", null, true);

    this.answer = function (accepted) {
        if (accepted) {
            $mdDialog.hide($scope.comment);
        }
        else {
            $mdDialog.cancel();
        }
    }
}
